import { Create, SimpleForm } from "@/components/admin";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { useTranslate } from "ra-core";
import { CampaignInputs } from "./CampaignInputs";

const transform = (data: any) => {
  return {
    ...data,
    revista: data.tipo === "edicao" ? data.revista : null,
    archived_at: null,
  };
};

export function CampaignCreate() {
  const translate = useTranslate();

  return (
    <div className="max-w-lg w-full mx-auto mt-8">
      <Card>
        <CardHeader>
          <CardTitle>
            {translate("resources.campaigns.action.create", {
              _: "Criar Campanha",
            })}
          </CardTitle>
        </CardHeader>
        <CardContent>
          <Create transform={transform} redirect="list">
            <SimpleForm>
              <CampaignInputs />
            </SimpleForm>
          </Create>
        </CardContent>
      </Card>
    </div>
  );
}
